module.exports = __webpack_public_path__ + "img/troll_shadow_priest_small.f16e5dd5.png";